import { ref, Ref } from "vue"
import { defineStore } from "pinia"
import { getUrbanPriority } from "@/utils/ApiClient"

type UrbanPriorityItem = { planType: string; priority: boolean }

export const useUrbanPrioritiesStore = defineStore("urbanPriority", () => {
	const urbanPriorities: Ref<UrbanPriorityItemWithParcelID[]> = ref([])

	type UrbanPriorityItemWithParcelID = UrbanPriorityItem & { parcelID: string }

	function updateByParcelId(id: string, planType: string, priority: boolean): UrbanPriorityItemWithParcelID {
		let urbanPriorityItem = urbanPriorities.value.find(p => p.parcelID === id && p.planType === planType) || null

		if (urbanPriorityItem) {
			urbanPriorityItem.priority = priority
		} else {
			urbanPriorityItem = { parcelID: id, planType, priority }
			urbanPriorities.value.push(urbanPriorityItem)
		}
		return urbanPriorityItem
	}

	// Wrapper sécurisé
	async function getUrbanPrioritySafe(token: string, parcelId: string): Promise<UrbanPriorityItem[]> {
		try {
			const data = await getUrbanPriority(token, parcelId as unknown as number)
			return data as UrbanPriorityItem[]
		} catch (error) {
			console.error("getUrbanPrioritySafe failed:", error)
			return []
		}
	}

	// Chargement initial pour une parcelle
	async function loadUrbanPriority(token: string, parcelId: string) {
		const result = await getUrbanPrioritySafe(token, parcelId)
		result?.forEach(({ planType, priority }) => {
			updateByParcelId(parcelId, planType, priority)
		})
	}

	return {
		urbanPriorities,
		updateByParcelId,
		loadUrbanPriority,
	}
})
